import joi from 'joi';

import type { NodeSn } from './nodes/types';

export interface GraphStpTechnology {
  vlanId: number;
  rootId: string;
}

export interface StpInstance extends GraphStpTechnology {
  grouped?: boolean;
  visible?: boolean;
}

export interface StpInstances {
  isolate?: boolean;
  instances: StpInstance[];
}

export interface GraphTechnologies {
  expandDeviceGroups?: NodeSn[];
  stpInstances?: StpInstances;
}

const stpInstance = joi.object().keys({
  grouped: joi.boolean(),
  rootId: joi.string().required(),
  visible: joi.boolean(),
  vlanId: joi.number().required(),
});

const expandDeviceGroupsSchema = joi.array().items(joi.string());

const stpInstancesSchema = joi.object().keys({
  isolate: joi.boolean(),
  instances: joi
    .array()
    .items(stpInstance)
    .required()
    .when('isolate', { is: true, then: joi.array().min(1) }),
});

export const graphTechnologiesSchema = joi.object().keys({
  expandDeviceGroups: expandDeviceGroupsSchema,
  stpInstances: stpInstancesSchema,
});
